<template>
  <div class="container-md">
    <div class="container-bg p-5">
      <h3 class="text-uppercase">Wachtwoord wijzigen</h3>
      <div v-if="canEditPassword" class="row">
        <div class="col-12 mt-3">
          <button
            type="button"
            class="btn text-white btn-dark"
            @click="openPwdModal()"
          >
            Genereer en stuur nieuw wachtwoord
          </button>
        </div>
      </div>
      <password-update
        v-model="item"
        :passwordReset="passwordReset"
        :error="error"
      />
      <div class="pb-4">
        <button
          @click="submit"
          :disabled="!isValidPassword || !isPasswordMatch"
          class="btn text-white btn-dark float-right"
        >
          <span v-if="!this.loading">Opslaan</span>
          <span v-else>Loading...</span>
        </button>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="genPwdModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="genPwdModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered idleModal-dialog">
        <div class="modal-content">
          <div class="modal-body inAct-modal-body text-center py-4">
            <p class="inActive-text pt-2">
              Weet je zeker dat je een nieuw wachtwoord wilt genereren en
              mailen?
            </p>

            <button
              type="button"
              class="btn btn-dark mt-3 mr-2"
              @click="closePwdModal()"
            >
              Nee
            </button>
            <button
              type="button"
              class="btn btn-dark mt-3"
              @click="generateNewPassword()"
            >
              Ja
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PasswordUpdate from "./password-update.vue";

export default {
  name: "profileDetail",
  components: { PasswordUpdate },
  data() {
    return {
      item: {
        password: "",
        repassword: "",
      },
      loading: false,
      isValidPassword: false,
      isPasswordMatch: false,
      error: "",
      image: null,
      edit: true,
      create: false,
      committees: [],
      subscriptions: [],
      selected_committees: [],
      selected_subscriptions: [],
      username_changed: false,
      passwordReset: false,
      pwd_error: "",
      validated: false,
    };
  },
  methods: {
    generateNewPassword(length = null, rules = null) {
      this.passwordReset = true;
      this.item.password = "";
      this.item.repassword = "";
      if (!length || length == undefined) {
        length = Math.floor(Math.random() * (20 - 10 + 1) + 10);
      }

      if (!rules || rules == undefined) {
        rules = [
          { chars: "abcdefghijklmnopqrstuvwxyz", min: 3 }, // As least 3 lowercase letters
          { chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZ", min: 2 }, // At least 2 uppercase letters
          { chars: "0123456789", min: 2 }, // At least 2 digits
          { chars: "!@#$&*?|%+-_./:;=()[]{}", min: 1 }, // At least 1 special char
        ];
      }

      var allChars = "",
        allMin = 0;
      rules.forEach((rule) => {
        allChars += rule.chars;
        allMin += rule.min;
      });
      if (length < allMin) {
        length = allMin;
      }
      rules.push({ chars: allChars, min: length - allMin });

      let pswd = "";
      rules.forEach((rule) => {
        if (rule.min > 0) {
          pswd += this.shuffleString(rule.chars, rule.min);
        }
      });
      let password = this.shuffleString(pswd);
      this.item.password = password;
      this.item.repassword = password;
      window.$("#genPwdModal").modal("hide");
    },

    shuffleString(str, maxlength) {
      let shuffledString = str
        .split("")
        .sort(function() {
          return 0.5 - Math.random();
        })
        .join("");
      if (maxlength > 0) {
        shuffledString = shuffledString.substr(0, maxlength);
      }
      return shuffledString;
    },

    submit() {
      if (this.loading) return;

      if (!(this.isValidPassword && this.isPasswordMatch)) return;

      this.loading = true;

      this.$store
        .dispatch("put", {
          endpoint: "api/v1/user/new-password/" + this.$route.params.id,
          details: this.item,
        })
        .then((data) => {
          if (data.data.redirect && data.data.redirect == true) {
            window.open(data.data.link, "_blank");
          } else {
            if (this.canEditPassword) {
              this.passwordReset = true;
            } else {
              window.location.href =
                "/profile/" + this.$route.params.id + "/view";
            }
          }
          this.$store.dispatch("auth/makeNotification", {
            status: "",
            statusText: "Wachtwoord gewijzigd",
          });

          this.loading = false;
          window.location.href = "/profile/" + this.$route.params.id + "/view";
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
          this.loading = false;
        });
    },

    openPwdModal() {
      window.$("#genPwdModal").modal("show");
    },

    closePwdModal() {
      window.$("#genPwdModal").modal("hide");
    },
  },
  created() {
    this.edit = this.$route.params.id == this.$store.state.auth.user.id;
  },
  computed: {
    isCurrentUserProfile() {
      return this.$store.state.auth.user.id == this.$route.params.id;
    },
    canEditPassword() {
      return (
        !this.isCurrentUserProfile &&
        this.userHasRoles(["Super-Admin", "Admin", "Ledenadministratie"])
      );
    },
  },
};
</script>

<style>
ul ul {
  list-style: none;
}
.validated {
  color: #0ccb68;
}
</style>
